import React from 'react';
import './HomePage.css';

const Products = () => {
  return (
    <div className='products-homepage'>
      <div className='container mt-5'>
        <div className='row'>
          <div className='col-lg-4 col-md-6 col-sm-12 mb-4'>
            <div className='card'>
              <img className='card-img-top' src='images/lt-panel.png' alt='LT Electrical Panel' />
              <div className='card-body'>
                <h5 className='card-title'>LT Electrical Panel</h5>
                <p className='card-text'>"Robust LT Electrical Panel ensuring reliable power distribution and control."</p>
              </div>
            </div>
          </div>

          <div className='col-lg-4 col-md-6 col-sm-12 mb-4'>
            <div className='card'>
              <img className='card-img-top' src='images/dg-panel.png' alt='DG Synchronization Panel' />
              <div className='card-body'>
                <h5 className='card-title'>APFCR Panel DG Synchronization Panel</h5>
                <p className='card-text'>"Efficient DG Synchronization Panel for seamless generator load sharing and control."</p>
              </div>
            </div>
          </div>

          <div className='col-lg-4 col-md-6 col-sm-12 mb-4'>
            <div className='card'>
              <img className='card-img-top' src='images/solar-panel.png' alt='Solar Solutions' />
              <div className='card-body'>
                <h5 className='card-title'>Solar Solutions</h5>
                <p className='card-text'>"Advanced solar solutions delivering sustainable energy with optimal efficiency and reliability."</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Products;